<template>
  <div class="reviews-testimonials-page" :class="$config.platform">
    <div class="hero-section">
      <div class="container">
        <div class="row centered">
          <div class="head">
            <h1 class="h2">
              <span class="highlight">REAL</span> Stories. <span class="highlight">REAL</span> Success.
            </h1>
            <p v-if="$config.platform === 'ds'">
              Meet <span class="strong">3,000,000+ learners</span> who achieve their career goals with us.
            </p>
            <p v-else>
              Thousands of learners achieve their career goals with us.
            </p>
            <p v-if="$config.platform === 'ds'">
              Want to share your success story in our 365 Data Science reviews? We'd love to hear from you!
            </p>
            <p v-else>
              Share your 365 Financial Analyst review and inspire others.
            </p>
            <a :href="$config.platform === 'ds' ? 'https://testimonial.to/365-data-science' : 'https://testimonial.to/365-financial-analyst'" target="_blank" class="btn-primary">
              Share Your Story
            </a>
          </div>
        </div>
      </div>
      <div class="logo-wrapper">
        <p>Our Graduates Work at</p>
        <SlidingAnimation v-if="$config.platform === 'ds'" class="companies-animation" horizontal>
          <div class="row">
            <IconTesla />
            <IconHsbc />
            <IconWalmart />
            <IconCitibank />
            <IconBooking />
            <IconAmazon />
            <IconPaypal />
            <IconGoogle />
            <IconApple />
            <IconMicrosoft />
            <IconMeta />
            <IconTesla />
            <IconHsbc />
            <IconWalmart />
            <IconCitibank />
            <IconBooking />
            <IconAmazon />
            <IconPaypal />
            <IconGoogle />
            <IconApple />
            <IconMicrosoft />
            <IconMeta />
          </div>
        </SlidingAnimation>
        <div v-else class="row">
          <IconBarclays />
          <IconBNP />
          <IconJPMorgan />
          <IconGoldmanSachs />
          <IconBankOfAmerica />
        </div>
      </div>
    </div>
    <div class="testimonials-section">
      <iframe
        v-if="$config.platform === 'ds'"
        id="testimonialto-365-data-science-tag-all-dark" src="https://embed-v2.testimonial.to/w/365-data-science?theme=dark&card=base&loadMore=on&initialCount=100&hideDate=on&tag=all&autoLoadMore&cc=off" frameborder="0"
        scrolling="no" width="100%"
      />
      <iframe
        v-else
        id="testimonialto-365-financial-analyst-tag-all-dark" src="https://embed-v2.testimonial.to/w/365-financial-analyst?theme=dark&card=base&loadMore=on&initialCount=100&hideDate=on&tag=all&autoLoadMore&cc=off" frameborder="0"
        scrolling="no" width="100%"
      />
    </div>
    <div class="banner">
      <div class="holder">
        <p v-if="$config.platform === 'ds'">
          These testimonials feature learners from esteemed universities:
        </p>
        <p v-else>
          Our learners landed finance jobs at leading companies like:
        </p>
        <div v-if="$config.platform === 'ds'" class="wrapper">
          <IconPrincetonUniversity />
          <IconBerkeleyUniversity />
          <IconColumbiaUniversity />
          <IconPennUniversity />
          <IconChicagoUniversity />
        </div>
        <div v-else class="wrapper">
          <IconBarclays />
          <IconBNP />
          <IconJPMorgan />
          <IconGoldmanSachs />
          <IconBankOfAmerica />
        </div>

        <p>Share your {{ $config.platformName }} review to have your story featured on our Wall of Success!</p>
      </div>
    </div>
    <div class="section stats light">
      <div class="holder">
        <StatsIcons
          v-if="$config.platform === 'ds'"
          class="container"
          :stats="stats" colored auto-width
          :order="['completedCourses', 'students', 'certificates']"
        />
        <StatsIcons
          v-else
          class="container"
          :stats="stats" colored auto-width
          :order="['students', 'rating', 'reviews']"
        />
      </div>
    </div>
    <div class="pre-footer">
      <p>Want to Be Part of Our <span class="highlight">Amazing</span> Community?</p>
      <nuxt-link
        to="/signup/"
        class="btn-primary"
      >
        Start Learning
      </nuxt-link>
    </div>
    <a
      class="up-arrow-btn"
      :class="{ 'visible': scrolled }"
      @click="scrollToTop"
    >
      <UpArrow />Top
    </a>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import SlidingAnimation from '@itbpbg/lms-components/src/Animations/Sliding.vue';
import IconHsbc from '@itbpbg/lms-components/src/assets/svg/companies/icon-hsbc-auto.svg?vue-component';
import IconWalmart from '@itbpbg/lms-components/src/assets/svg/companies/icon-walmart-auto.svg?vue-component';
import IconCitibank from '@itbpbg/lms-components/src/assets/svg/companies/icon-citibank-auto.svg?vue-component';
import IconPaypal from '@itbpbg/lms-components/src/assets/svg/companies/icon-paypal-auto.svg?vue-component';
import IconBooking from '@itbpbg/lms-components/src/assets/svg/companies/icon-booking-auto.svg?vue-component';
import IconGoogle from '@itbpbg/lms-components/src/assets/svg/companies/icon-google-auto.svg?vue-component';
import IconApple from '@itbpbg/lms-components/src/assets/svg/companies/icon-apple-auto.svg?vue-component';
import IconMicrosoft from '@itbpbg/lms-components/src/assets/svg/companies/icon-microsoft-auto.svg?vue-component';
import IconAmazon from '@itbpbg/lms-components/src/assets/svg/companies/icon-amazon-auto.svg?vue-component';
import IconTesla from '@itbpbg/lms-components/src/assets/svg/companies/icon-tesla-auto.svg?vue-component';
import IconMeta from '@itbpbg/lms-components/src/assets/svg/companies/icon-meta-auto.svg?vue-component';
import IconPrincetonUniversity from '@itbpbg/lms-components/src/assets/svg/icon-princeton-uni.svg?vue-component';
import IconBerkeleyUniversity from '@itbpbg/lms-components/src/assets/svg/icon-berkeley-uni.svg?vue-component';
import IconColumbiaUniversity from '@itbpbg/lms-components/src/assets/svg/icon-columbia-uni.svg?vue-component';
import IconPennUniversity from '@itbpbg/lms-components/src/assets/svg/icon-penn-uni.svg?vue-component';
import IconChicagoUniversity from '@itbpbg/lms-components/src/assets/svg/icon-chicago-uni.svg?vue-component';
import IconBankOfAmerica from '@itbpbg/lms-components/src/assets/svg/companies/icon-bank-of-america-auto.svg?vue-component';
import IconBarclays from '@itbpbg/lms-components/src/assets/svg/companies/icon-barclays-auto.svg?vue-component';
import IconBNP from '@itbpbg/lms-components/src/assets/svg/companies/icon-bnp-auto.svg?vue-component';
import IconGoldmanSachs from '@itbpbg/lms-components/src/assets/svg/companies/icon-goldman-sachs-auto.svg?vue-component';
import IconJPMorgan from '@itbpbg/lms-components/src/assets/svg/companies/icon-j-p-morgan-auto.svg?vue-component';
import UpArrow from '../assets/svg/icon-arrow-blog-up.svg?vue-component';
import StatsIcons from '../components/Campaigns/StatsIcons';

export default {
  components: {
    StatsIcons,
    SlidingAnimation,
    IconHsbc,
    IconWalmart,
    IconCitibank,
    IconPaypal,
    IconBooking,
    IconGoogle,
    IconApple,
    IconMicrosoft,
    IconAmazon,
    IconTesla,
    IconMeta,
    IconPrincetonUniversity,
    IconBerkeleyUniversity,
    IconColumbiaUniversity,
    IconPennUniversity,
    IconChicagoUniversity,
    UpArrow,
    IconBankOfAmerica,
    IconBarclays,
    IconBNP,
    IconGoldmanSachs,
    IconJPMorgan,
  },
  mixins: [global],
  async asyncData({
    $axios, route, $config, error,
  }) {
    const [page, stats] = await Promise.all([
      $axios.$get(`/pages/${route.fullPath}`).catch(() => false),
      $axios.$get('/stats/courses?reduced=1').catch(() => ({})),
    ]);

    if (!page) {
      return error({ title: 'Not found', statusCode: 404, message: 'Page not found' });
    }

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return {
      page,
      stats,
    };
  },
  data() {
    return {
      scrolled: false,
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.$config.platform === 'ds' ? '365 Data Science Reviews' : '365 Financial Analyst Reviews'}`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [
        linkedData,
        { src: 'https://testimonial.to/js/iframeResizer.min.js' },
      ],
    };
  },
  created() {
    this.handleScroll();
  },
  async mounted() {
    await this.$pollValue(() => typeof iFrameResize !== 'undefined');
    // eslint-disable-next-line no-undef
    iFrameResize({ log: false, checkOrigin: false }, `${this.$config.platform === 'ds' ? '#testimonialto-365-data-science-tag-all-dark' : '#testimonialto-365-financial-analyst-tag-all-dark'}`);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll() {
      if (process.client) {
        window.onscroll = () => {
          this.scrolled = window.scrollY > 0 && this.$store.state.layout === 'desktop';
        };
      }
    },
  },
};
</script>

<style lang="scss">
.reviews-testimonials-page {
  .hero-section {
    position: relative;
    min-height: 400px;
    background-image: url('../assets/images/hero-testimonials-page-reviews.webp');
    image-rendering: -webkit-optimize-contrast;
    color: var(--true-white);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    background-color: var(--main-dark);
    margin-bottom: var(--spacing-36);
    padding-bottom: 16px;
    padding-top: 80px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: unset;

    &:after {
      content: '';
      width: 100%;
      height: 38px;
      background: var(--main-dark);
      position: absolute;
      bottom: -37px;
      left: 0;
    }

    .container {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    .head {
      max-width: 100%;
      width: 970px;

      h1 {
        margin-bottom: 0;

        .highlight {
          color: var(--main-yellow);
          font-weight: 700;
        }
      }

      p {
        font-size: 21px;
        color: var(--main-light);
        padding: 0;
        margin: 0;

        .strong {
          font-weight: 700;
        }

        &:first-of-type  {
          margin: var(--spacing-16) 0 var(--spacing-8);
          line-height: 140%;
        }

        &:last-of-type {
          font-size: 18px;
          font-weight: 400;
          line-height: 150%;
        }
      }

      .btn-primary {
        width: 300px;
        height: 58px;
        margin-top: var(--spacing-20);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 16px auto 0;
      }
    }

    .logo-wrapper {
      width: 100%;
      overflow: hidden;

      p {
        font-size: 18px;
        font-weight: 500;
        line-height: 110%;
        margin-top: 0;
        margin-bottom: var(--spacing-8);
      }

      .companies-animation {
        display: flex;
        width: min-content;

        .row {
          flex-flow: nowrap;
        }

        svg {
          margin-right: 80px;
          width: 96px;
          height: 32px;
        }
      }
    }
  }

  .testimonials-section {
    background-color: var(--main-dark);
  }

  .banner {
    background: var(--main-dark);
    padding: var(--spacing-32) 0 var(--spacing-60);

    .holder {
      width: 1170px;
      margin: 0 auto;
      color: var(--main-light);
    }

    .wrapper {
      display: flex;
      flex-flow: wrap;
      column-gap: 116px;

      svg {
        height: 52px;
        padding: 5px 0;

        &:nth-child(3) {
          padding: 0;
          height: 56px;
        }

        &:nth-child(2) {
          padding: 8px 0;
        }
      }
    }

    p {
      color: var(--main-light);
      text-align: center;
      font-weight: 500;
      line-height: 110%;

      &:first-of-type {
        margin-top: 0;
        margin-bottom: var(--spacing-8);
        font-size: 24px;
      }

      &:last-of-type {
        margin-bottom: 0;
        margin-top: var(--spacing-32);
        font-size: 18px;
      }
    }
  }

  .section {
    background-size: cover;
    background-position: bottom;
    padding-top: 40px;
    padding-bottom: 40px;
    height: 190px;

    &.light {
      background-color: var(--main-dark-light-1);
    }

    .section-title,
    .instructors ::v-deep .infinite-head .h4 {
      text-align: center;
    }

    .stats-icons {
      margin: 22px auto;
      justify-content: center;

      > div {
        width: 370px;
        margin-right: 30px;
        justify-content: center;
        align-items: center;
      }

      div:last-of-type {
        margin-right: 0;
      }

      svg {
        width: 90px;
        height: 90px;
      }

      .description {
        font-size: 21px;
      }

      .icon-students {
        path {
          &:nth-child(2),
          &:nth-child(4) {
            stroke: var(--main-yellow);
          }
        }
      }
    }
  }

  .pre-footer {
    background-image: url('../assets/images/footer-reviews-testimonials-page.webp');
    background-color: var(--main-dark);
    min-height: 595px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: unset;

    p {
      color: var(--main-light);
      font-size: 40px;
      font-weight: 500;
      line-height: 110%;
      margin-top: 80px;

      .highlight {
        color: var(--main-yellow);
        text-transform: uppercase;
        font-weight: 700;
      }
    }

    .btn-primary {
      width: 300px;
      height: 58px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .up-arrow-btn {
    background: var(--main-dark-shade-1);
    border-radius: 3px;
    color: var(--main-light);
    height: 56px;
    margin: -116px var(--spacing-48) var(--spacing-60) auto;
    padding: var(--spacing-12);
    position: sticky;
    text-align: center;
    width: 56px;
    transition: all var(--duration) ease-in;
    opacity: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    bottom: 54px;

    &.visible {
      opacity: 1;
    }

    svg {
      margin-bottom: 5px;

      path[stroke] {
        stroke: var(--main-light);
      }
    }

    &:hover {
      color: var(--main-light);
    }
  }

  &.fa {
    .hero-section {
      background-image: url('../assets/images/fa-hero-testimonials-page-reviews.webp');

      .head p:first-of-type {
        font-weight: 500;
      }

      .logo-wrapper .row {
        flex-flow: unset;
        justify-content: center;
        width: 970px;
        margin: 0 auto;

        svg {
          width: 120px;
          height: 40px;
          margin-right: 88px;

          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }

    .banner {
      p:first-of-type {
        margin-bottom: 10;
      }

      .wrapper {
        column-gap: 87px;

        svg {
          height: 40px;
          padding: 0;

          &:nth-child(2),
          &:nth-child(3) {
            padding: 0;
          }
        }
      }
    }

    .section {
      .stats-icons {
        .icon-students {
          path {
            &:nth-child(2),
            &:nth-child(4) {
              stroke: var(--main-yellow);
            }
          }
        }

        .icon-reviews {
          padding: 9px;
        }
      }
    }

    .pre-footer {
      background-image: url('../assets/images/fa-footer-reviews-testimonials-page.webp');
    }
  }
}

@include bp($bp-laptop) {
  .reviews-testimonials-page {
    .hero-section {
      .head {
        .btn-primary {
          width: 225px;
        }
      }
    }

    .banner {
      p:first-of-type {
        font-size: 21px;
      }
      .holder {
        width: 990px;
      }

      .wrapper {
        column-gap: 71px;
      }
    }

    .section {
      .stats-icons {
        svg {
          width: 60px;
          height: 60px;
        }

        .description {
          font-size: 18px;
        }

        > div {
          width: 253px;
          margin-right: 115px;
        }
      }
    }

    .pre-footer {
      p {
        font-size: 32px;
      }

      .btn-primary {
        width: 225px;
      }
    }

    &.fa {
      .banner {
        .wrapper {
          column-gap: 42px;
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .reviews-testimonials-page {
    .hero-section {
      background-image: url('../assets/images/hero-testimonials-page-reviews-mobile.webp');
      min-height: 580px;

      .head {
        width: unset;

        h1 {
          font-size: 32px;
        }

        p {
          padding: 0 10px;

          &:first-of-type {
            margin-top: 12px;
          }
        }

        .btn-primary {
          max-width: 327px;
          width: 100%;
        }
      }

    }

    .banner {
      padding: var(--spacing-32) var(--spacing-24) var(--spacing-60);

      p:first-of-type {
        font-size: 21px;
      }

      .holder {
        width: 100%;
      }

      .wrapper {
        flex-direction: column;

        svg {
          width: 156px;
          margin: 0 auto 20px;
          padding: 0;

          &:last-of-type {
            margin-bottom: 0;
          }
        }
      }
    }

    .section {
      height: unset;
      padding-left: var(--spacing-24);
      padding-right: var(--spacing-24);

      .stats-icons {
        > div {
          width: 253px;
          justify-content: flex-start;
          margin-right: auto;

          svg {
            width: 60px;
            height: 60px;
          }
        }

        div:last-of-type {
          margin-right: auto;
        }

        .description {
          font-size: 18px;
        }
      }
    }

    .pre-footer {
      background-image: url('../assets/images/footer-reviews-testimonials-page-mobile.webp');
      min-height: 525px;
      padding: 0 var(--spacing-24);

      .btn-primary {
        width: 100%;
      }

      p {
        font-size: 32px;
        text-align: center;
        margin-bottom: var(--spacing-40);
      }
    }

    .up-arrow-btn {
      margin-right: 24px;
    }

    &.fa {
      .hero-section {
        min-height: 755px;
        background-image: url('../assets/images/fa-hero-testimonials-page-reviews-mobile.webp');

        .logo-wrapper {
          .row {
            flex-flow: column;
            align-items: center;
            width: unset;

            svg {
              margin-right: 0;
              margin-bottom: var(--spacing-16);

              &:last-of-type {
                margin-bottom: 0;
              }
            }
          }
        }
      }

      .pre-footer {
        background-image: url('../assets/images/fa-footer-reviews-testimonials-page-mobile.webp');
      }
    }
  }
}
</style>
